var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","id":"file","name":"file","accept":".jpg, .jpeg, .png, .webp"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }